(() => {
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  const collectionV2RootSelector = '[data-collection-v2-root]';
  const navigateWithSort = (value) => {
    if (!value) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', value);
    window.location.assign(url.toString());
  };

  const initialiseDrawer = (drawer) => {
    const panel = drawer.querySelector('.collection-v2-filter-drawer__panel');
    const openers = document.querySelectorAll(`[aria-controls="${drawer.id}"]`);
    const closers = drawer.querySelectorAll('[data-collection-v2-filter-close]');
    let lastFocusedElement = null;
    const close = () => {
      drawer.hidden = true;
      document.body.classList.remove('collection-v2-filter-open');
      openers.forEach((opener) => opener.setAttribute('aria-expanded', 'false'));
      lastFocusedElement?.focus();
    };
    const open = (opener) => {
      lastFocusedElement = opener;
      drawer.hidden = false;
      document.body.classList.add('collection-v2-filter-open');
      openers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      window.setTimeout(() => panel.focus(), 0);
    };
    openers.forEach((opener) => opener.addEventListener('click', () => open(opener)));
    closers.forEach((closer) => closer.addEventListener('click', close));
    panel.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll(focusableSelector)].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
    document.addEventListener('keydown', (event) => {
      if (!drawer.hidden && event.key === 'Escape') close();
    });
  };

  const initialiseChatPlacement = () => {
    const labelDisplayValues = new WeakMap();
    const activatorSizeValues = new WeakMap();
    const getChatSurface = (chatHost) => {
      const hostRoot = chatHost?.shadowRoot;
      const runtimeRoot = hostRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
      return runtimeRoot || hostRoot;
    };
    const updateChatPlacement = () => {
      if (!document.body.classList.contains('collection-v2-active')) return;
      const chatHost = document.querySelector('shopify-chat');
      const chatSurface = getChatSurface(chatHost);
      const chatNudge = chatSurface?.querySelector('.activator-nudge--right');
      const activator = chatSurface?.querySelector('.activator');
      const label = chatSurface?.querySelector('.activator__label');
      if (!chatNudge) return;
      const isMobile = window.matchMedia('(max-width: 768px)').matches;
      chatNudge.style.setProperty('right', isMobile ? '14px' : '20px', 'important');
      chatNudge.style.setProperty('bottom', isMobile ? '96px' : '28px', 'important');

      if (isMobile) {
        if (label && !labelDisplayValues.has(label)) {
          labelDisplayValues.set(label, label.style.getPropertyValue('display'));
        }
        label?.style.setProperty('display', 'none', 'important');
        if (activator && !activatorSizeValues.has(activator)) {
          activatorSizeValues.set(activator, {
            width: activator.style.getPropertyValue('width'),
            height: activator.style.getPropertyValue('height'),
          });
        }
        activator?.style.setProperty('width', '48px', 'important');
        activator?.style.setProperty('height', '48px', 'important');
        return;
      }

      if (label && labelDisplayValues.has(label)) {
        const display = labelDisplayValues.get(label);
        if (display) label.style.setProperty('display', display);
        else label.style.removeProperty('display');
        labelDisplayValues.delete(label);
      }
      if (activator && activatorSizeValues.has(activator)) {
        const size = activatorSizeValues.get(activator);
        if (size.width) activator.style.setProperty('width', size.width);
        else activator.style.removeProperty('width');
        if (size.height) activator.style.setProperty('height', size.height);
        else activator.style.removeProperty('height');
        activatorSizeValues.delete(activator);
      }
    };

    window.addEventListener('resize', updateChatPlacement, { passive: true });
    const watchChat = () => {
      const chatHost = document.querySelector('shopify-chat');
      if (!chatHost?.shadowRoot) return false;
      let observedRuntimeRoot = null;
      let runtimeObserver = null;
      const observeRuntime = () => {
        const runtimeRoot = chatHost.shadowRoot.querySelector('shopify-agent-runtime')?.shadowRoot;
        if (!runtimeRoot || runtimeRoot === observedRuntimeRoot) return;
        runtimeObserver?.disconnect();
        observedRuntimeRoot = runtimeRoot;
        runtimeObserver = new MutationObserver(updateChatPlacement);
        runtimeObserver.observe(runtimeRoot, { childList: true, subtree: true });
      };
      updateChatPlacement();
      observeRuntime();
      const chatObserver = new MutationObserver(() => {
        observeRuntime();
        updateChatPlacement();
      });
      chatObserver.observe(chatHost.shadowRoot, { childList: true, subtree: true });
      return true;
    };

    if (!watchChat()) {
      const hostObserver = new MutationObserver(() => {
        if (watchChat()) hostObserver.disconnect();
      });
      hostObserver.observe(document.body, { childList: true, subtree: true });
    }
  };

  const initialise = () => {
    if (!document.querySelector(collectionV2RootSelector)) return;
    document.body.classList.add('collection-v2-active');
    initialiseChatPlacement();
    document.querySelectorAll('[data-collection-v2-filter-drawer]').forEach(initialiseDrawer);
    document.querySelectorAll('[data-collection-v2-sort]').forEach((control) => {
      control.addEventListener('change', (event) => navigateWithSort(event.target.value));
      control.addEventListener('click', (event) => {
        if (control.tagName === 'BUTTON') navigateWithSort(event.currentTarget.value);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();
